var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.08119115882756511"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.414 0.0151567C204.414 0.0151567 206.837 93.9509 150.394 150.394C93.9507 206.837 0.0151569 204.413 0.0151569 204.413C0.0151569 204.413 -2.40835 110.478 54.0347 54.0349C110.478 -2.40834 204.414 0.0151567 204.414 0.0151567Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.414 0.0151567C204.414 0.0151567 206.837 93.9509 150.394 150.394C93.9507 206.837 0.0151569 204.413 0.0151569 204.413C0.0151569 204.413 -2.40835 110.478 54.0347 54.0349C110.478 -2.40834 204.414 0.0151567 204.414 0.0151567Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1.4634146341463414, 1.4634146341463414)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.414 0.0151567C204.414 0.0151567 206.837 93.9509 150.394 150.394C93.9507 206.837 0.0151569 204.413 0.0151569 204.413C0.0151569 204.413 -2.40835 110.478 54.0347 54.0349C110.478 -2.40834 204.414 0.0151567 204.414 0.0151567Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.08119115882756511)",
    transform: "scale(1.4634146341463414, 1.4634146341463414)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg37);
export default __webpack_public_path__ + "static/media/37.259c90cd7f9c6596a0a82928889b18f1.svg";
export { ForwardRef as ReactComponent };